/* import React, { useState } from 'react';
import Formulaire from './Formulaire';
import { ParticipantsIpmService } from '../Services/ParticipantsIpmService';

const NewParticipantIpm = () => {
  const participantsIpmService = new ParticipantsIpmService();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleAjoutSubmit = async (values) => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const numcont = `${values.codesoc}-${values.matricule}`;
      const matipm = `${values.codesoc}-${values.matricule}-1`;

      const updatedValues = {
        ...values,
        numcont,
        matipm,
        compte: values.compte || "",
        etat: values.etat || 'A',
        datecreationpart: values.datecreationpart || "",
        datedebcarte: values.datedebcarte || "",
        datefincarte: values.datefincarte || "",
        dateemb: values.dateemb || "",
        datenaiss: values.datenaiss || "",
        dateradiation: values.dateradiation || "",
        dateres: values.dateres || "",
        datesous: values.datesous || "",
        type_piece: values.type_piece,
        etatcont: values.etatcont,
        cin: values.cin || "",
        codedept: values.codedept || "",
        codedir: values.codedir || "",
        codeserv: values.codeserv || "",
        email: values.email || "",
        lieunaiss: values.lieunaiss || "",
        nom: values.nom || "",
        pays: values.pays || "",
        photo: values.photo || "",
        portable: values.portable || "",
        prenom: values.prenom || "",
        region: values.region || "",
        sexe: values.sexe || "",
        sitfam: values.sitfam || "",
        categprof: values.categprof || null,
        codeaffect: values.codeaffect || "",
        numfiche: values.numfiche || "",
      };

      await participantsIpmService.addParticipantIpm(updatedValues);
      const updatedList = await participantsIpmService.getAllParticipantsIpm();

      setSuccess('Participant ajouté avec succès');
    } catch (error) {
      setError('Erreur lors de l\'ajout de participant : ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && <p>Chargement...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {success && <p style={{ color: 'green' }}>{success}</p>}
      <Formulaire onSubmit={handleAjoutSubmit} mode="add" />
    </div>
  );
}

export default NewParticipantIpm;
 */

import React, { useState } from 'react';
import dayjs from "dayjs";
import { notification } from 'antd';
import Formulaire from './Formulaire';
import { ParticipantsIpmService } from '../Services/ParticipantsIpmService';

const NewParticipantIpm = () => {
  const participantsIpmService = new ParticipantsIpmService();
  const [loading, setLoading] = useState(false);

  const handleAjoutSubmit = async (values) => {
    setLoading(true);

    try {
      const numcont = `${values.codesoc}-${values.matricule}`;
      const matipm = `${values.codesoc}-${values.matricule}-1`;

      const formatLocalDateTime = (value) =>
        value ? dayjs(value).format("YYYY-MM-DDTHH:mm:ss") : "";

      const updatedValues = {
        ...values,
        numcont,
        matipm,
        compte: values.compte || "",
        etat: values.etat || 'A',
        datecreationpart: formatLocalDateTime(values.datecreationpart),
        datedebcarte: values.datedebcarte || "",
        datefincarte: values.datefincarte || "",
        dateemb: values.dateemb || "",
        datenaiss: values.datenaiss || "",
        dateradiation: values.dateradiation || "",
        dateres: values.dateres || "",
        datesous: values.datesous || "",
        type_piece: values.type_piece,
        etatcont: values.etatcont,
        cin: values.cin || "",
        codedept: values.codedept || "",
        codedir: values.codedir || "",
        codeserv: values.codeserv || "",
        email: values.email || "",
        lieunaiss: values.lieunaiss || "",
        nom: values.nom || "",
        pays: values.pays || "",
        photo: values.photo || "",
        portable: values.portable || "",
        prenom: values.prenom || "",
        region: values.region || "",
        sexe: values.sexe || "",
        sitfam: values.sitfam || "",
        categprof: values.categprof || null,
        codeaffect: values.codeaffect || "",
        numfiche: values.numfiche || "",
      };

      // Appel à l'API pour ajouter le participant
      const response = await participantsIpmService.addParticipantIpm(updatedValues);

      // Vérifier si "Added: false" est retourné dans la réponse du serveur
      /* if (response.Added === false) {
        notification.error({
          message: 'Erreur',
          description: 'Matricule participant existant.',
        });
      } else {
        notification.success({
          message: 'Succès',
          description: 'Participant ajouté avec succès',
        });
      }
      await participantsIpmService.getAllParticipantsIpm(); */
      return response
    } catch (error) {
      notification.error({
        message: 'Erreur',
        description: `Erreur lors de l'ajout du participant : ${error.message}`,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && <p>Chargement...</p>}
      <Formulaire onSubmit={handleAjoutSubmit} mode="add" />
    </div>
  );
};

export default NewParticipantIpm;
